export default __webpack_public_path__ + "static/media/bookdoc-logo.06c0ad0c.svg";